'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var scrollState = function scrollState() {
  var scrolls = document.querySelectorAll('[data-scroll-state]');

  scrolls.forEach(function (element, index) {
    var updateScroll = function updateScroll() {
      var scrollPos = element.scrollTop;
      var scrollHeight = element.scrollHeight - element.offsetHeight;

      if (scrollPos > 0) {
        element.classList.add('scroll-top');
      } else {
        element.classList.remove('scroll-top');
      }

      if (scrollPos < scrollHeight) {
        element.classList.add('scroll-bottom');
      } else {
        element.classList.remove('scroll-bottom');
      }
    };

    element.addEventListener('scroll', updateScroll);
    window.addEventListener('resize', updateScroll);
    window.addEventListener('orientationchange', updateScroll);
    updateScroll();
  });

  if (location.hash && location.pathname.indexOf('challenge') !== -1) {
    setTimeout(function () {

      window.scrollTo(0, 0);
    }, 1);
  }
};

exports.default = scrollState;